<div class="screen-element dashboard">
	<app-statusbar class="screen-element"></app-statusbar>
	<div class="dashboard-center">
		<div *ngIf="!dashIcon" class="value">{{value}}</div>
		<div *ngIf="!dashIcon" class="unit">{{unit}}</div>
		<div *ngIf="dashIcon" class="icon {{dashIcon}}"></div>
	</div>
	<text-widget [color]="'white'" class="text text-1" [text]="getText(0)"></text-widget>
	<text-widget [color]="'white'" class="text text-2" [text]="getText(1)"></text-widget>
	<text-widget [color]="'grey'" class="text text-3" [text]="getText(2)"></text-widget>
	<!--
		<div class="text text-1">{{getText(0)}}</div>
		<div class="text text-2">{{getText(1)}}</div>
		<div class="text text-3">{{getText(2)}}</div>
	-->
</div>